import { isPlatformBrowser } from '@angular/common';
import { DOCUMENT, inject, Injectable, PLATFORM_ID } from '@angular/core';
import { WARN } from '@padspin/ui-logger';

const lastReloadKey = 'padspin-missing-chunk-reload-at';

/**
 * Moves a tab that booted on an earlier deploy onto the current one, by
 * loading a page in full once that deploy's lazy chunks are gone.
 */
@Injectable({ providedIn: 'root' })
export class MissingChunkReloadService {
  private readonly document = inject(DOCUMENT);
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  private readonly warn = inject(WARN);

  /**
   * Loads `url` as a full page, or reloads the current page when `url` is
   * omitted. Does nothing if it already did so within the last minute, so a
   * chunk missing from the current build can't loop.
   */
  loadFreshPage(cause: unknown, url?: string): void {
    if (!this.isBrowser) {
      return;
    }
    try {
      const last = Number(sessionStorage.getItem(lastReloadKey));
      if (Date.now() - last < 60_000) {
        return;
      }
      sessionStorage.setItem(lastReloadKey, String(Date.now()));
    } catch {
      return;
    }
    this.warn('[MissingChunk] Chunk failed to load, reloading', cause);
    if (url === undefined) {
      this.document.location.reload();
    } else {
      this.document.location.assign(url);
    }
  }
}
